import { Card, CardBody, Col } from "reactstrap";
import { FontWeight } from "../../../../Constant";
import { FONT_WEIGHT, FONT_WEIGHT_DATA } from "../../../../Data/UiKit/HelperClasses";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const FontWeightCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={FontWeight} span={FONT_WEIGHT} />
        <CardBody>
          <div className="d-flex align-items-center mb-2 gap-2">
            <div className="f-w-100">You can set light font weight heading .f-w-100</div>
          </div>
          {FONT_WEIGHT_DATA.map((item, index) => (
            <div className="d-flex align-items-center mb-2 gap-2" key={index}>
              <div className={item}>{`You can set light font weight heading .${item}`}</div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default FontWeightCart;
